/**
 * متدهای گرد کردن برای محاسبات کالری و مقادیر غذایی
 * کپی شده از فرانت قدیم FoodMenu.jsx و new_front
 */

/**
 * گرد کردن به مضرب 0.5
 * @param {number} num - عدد ورودی
 * @returns {number} - عدد گرد شده
 */
export const customRound = (num) => {
  if (isNaN(num) || !isFinite(num)) {
    console.warn("ورودی customRound نامعتبر است:", num);
    return 0;
  }

  // برای مقادیر کمتر از 0.25، 0 برگردونیم
  if (num < 0.25) {
    return 0;
  }

  // محاسبه شماره‌ی بازه
  const interval = Math.floor((num - 0.25) / 0.5) + 1;

  // تبدیل به مضرب 0.5
  return interval * 0.5;
};

/**
 * گرد کردن به مضرب 5
 * @param {number} num - عدد ورودی
 * @returns {number} - عدد گرد شده
 */
export const customRound2 = (num) => {
  if (isNaN(num) || !isFinite(num)) {
    console.warn("ورودی customRound2 نامعتبر است:", num);
    return 5;
  }

  // برای مقادیر منفی یا صفر، حداقل 5 برگردانیم
  if (num <= 0) {
    console.warn("مقدار ورودی customRound2 صفر یا منفی است:", num);
    return 5;
  }

  // اگر x < 7.5 باشد، طبق الگو باید 5 برگردانیم
  if (num < 7.5) {
    return 5;
  }

  // برای بازه‌های 7.5 و بالاتر:
  // جابه‌جایی به گونه‌ای که بازه‌ها (مثل 12.5 تا 17.5) به درستی به مضرب 5 نگاشت شوند
  const adjustedNum = num - 7.5; // کم کردن 7.5 برای تنظیم بازه‌ها
  const rounded = (Math.floor(adjustedNum / 5) + 2) * 5; // استفاده از Math.floor و اضافه کردن 2 برای نگاشت درست

  return rounded;
};

/**
 * گرد کردن به نزدیک‌ترین عدد صحیح
 * @param {number} num - عدد ورودی
 * @returns {number} - عدد گرد شده
 */
export const customRoundFull = (num) => {
  if (isNaN(num) || !isFinite(num)) {
    console.warn("ورودی customRoundFull نامعتبر است:", num);
    return 1;
  }

  // برای مقادیر منفی یا صفر، حداقل 1 برگردونیم
  if (num <= 0) {
    console.warn("مقدار ورودی customRoundFull صفر یا منفی است:", num);
    return 1;
  }

  // به نزدیک‌ترین عدد صحیح گرد می‌کنیم
  const rounded = Math.round(num);

  // حداقل مقدار 1 را تضمین می‌کنیم
  return Math.max(rounded, 1);
};

/**
 * دسته‌بندی کسری به متن فارسی
 * @param {number} value - مقدار ورودی
 * @returns {string} - متن فارسی
 */
export const categorizeFraction = (value) => {
  if (isNaN(value) || !isFinite(value)) {
    console.warn("ورودی categorizeFraction نامعتبر است:", value);
    return "یک چهارم";
  }

  if (value <= 0) {
    console.warn("مقدار ورودی categorizeFraction نامعتبر است:", value);
    return "یک چهارم";
  }

  if (value >= 4.125) {
    return Math.round(value);
  }

  if (value < 0.125) return "یک چهارم";
  if (value < 0.375) return "یک چهارم";
  if (value < 0.625) return "نیم";
  if (value < 0.875) return "سه چهارم";
  if (value < 1.125) return "یک";
  if (value < 1.375) return "یک و یک چهارم";
  if (value < 1.625) return "یک و نیم";
  if (value < 1.875) return "یک و سه چهارم";
  if (value < 2.125) return "دو";
  if (value < 2.375) return "دو و یک چهارم";
  if (value < 2.625) return "دو و نیم";
  if (value < 2.875) return "دو و سه چهارم";
  if (value < 3.125) return "سه";
  if (value < 3.375) return "سه و یک چهارم";
  if (value < 3.625) return "سه و نیم";
  if (value < 3.875) return "سه و سه چهارم";
  if (value < 4.125) return "چهار";

  return "یک";
};

/**
 * گرد کردن به روش round_quarter (دسته‌بندی کسری)
 * @param {number} num - عدد ورودی
 * @returns {string} - متن فارسی
 */
export const roundQuarter = (num) => {
  if (isNaN(num) || !isFinite(num)) {
    console.warn("ورودی roundQuarter نامعتبر است:", num);
    return "یک";
  }

  if (num <= 0) {
    console.warn("مقدار ورودی roundQuarter نامعتبر است:", num);
    return "یک";
  }

  return categorizeFraction(num);
};

/**
 * تبدیل عدد به عدد معتبر
 * @param {any} value - مقدار ورودی
 * @param {number} defaultValue - مقدار پیش‌فرض
 * @returns {number} - عدد معتبر
 */
export const parseNumber = (value, defaultValue = 0) => {
  const parsed = parseFloat(value);
  return isNaN(parsed) ? defaultValue : parsed;
};

